// Reads the player's juice settings (speed, shake %, reduce flashing) for all fx.
import { store, TEST_MODE } from '../state/store';
import { computeModifiers } from '../sim/modifiers';
import { handInterval } from '../sim/hand';

export const juice = {
  /** Animation speed: the setting, compressed further while the Hand autospins (docs/07 §2). */
  speed(): number {
    if (TEST_MODE) return 50;
    const g = store.getState().game;
    const base = g.meta.settings.speed;
    if (!g.meta.hand.autospin) return base;
    return base * Math.max(1, 1.6 / handInterval(computeModifiers(g.meta, g.run)));
  },
  shake(): number {
    return TEST_MODE ? 0 : store.getState().game.meta.settings.shake;
  },
  reduceFlashing(): boolean {
    return store.getState().game.meta.settings.reduceFlashing;
  },
  crt(): boolean {
    return store.getState().game.meta.settings.crt && !store.getState().game.meta.settings.reduceFlashing;
  },
};
